// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports

export default function UserRoleAndViewRow() {
   const state = useQuoteContext()

   return (
      <div className='row'>
         <div className='col-bhr1 col-bhr5 input-group flex-nowrap'>
            <select
               className='form-select-bhr1'
               value={state.user_role}
               onChange={(e) => state.setuser_role(e.target.value)}
            >
               {state.user_roles.map((e, key) => {
                  return (
                     <option key={key} value={e.value}>
                        {e.name}
                     </option>
                  )
               })}
            </select>
         </div>
         <div className='col-bhr1 col-bhr5 input-group flex-nowrap'>
            {/* <select className="form-select-bhr1" value={state.user_view} onChange={e => state.setuser_view(e.target.value)}>
                    {state.user_views.map((e, key) => {
                        return <option key={key} value={e.value}>{e.name}</option>;
                    })}
                </select> */}
         </div>
      </div>
   )
}
